<template>
  <div>
    <div class="content">
      <LoginLogo />

      <v-form ref="form" :disabled="formSubmitted" v-on:submit.prevent="forgotPassword">
        <v-container>
          <v-row>
            <v-text-field
              v-model="email"
              v-bind:rules="emailRules"
              v-bind:error-messages="emailErrors"
              label="email"
              prepend-inner-icon="mdi-at"
              variant="solo-filled" flat
              block
              required>
            </v-text-field>
          </v-row>

          <v-row>
            <div class="bg-success mb-2" v-if="successMessage"> {{ successMessage }} </div>
          </v-row>

          <v-row>
            <v-btn id="reset-password" type="submit" :disabled="formSubmitted" class="bg-primary" block>Reset Password</v-btn>
          </v-row>
        </v-container>
      </v-form>

      <div class="text-center mt-3">
        <router-link to="/account/reset-password">Verify new password</router-link>
      </div>
    </div>

    <div class="text-center mt-5">
      <router-link to="/account/login">Go to the login page</router-link>
    </div>
  </div>
</template>

<script>
import { useAuthStore } from '@/stores/AuthStore'
import LoginLogo from './components/LoginLogo.vue'
import Helper from '@/components/helper.js';

export default {
  name: 'ForgotPassword',
  components: {
    LoginLogo,
  },
  data: function() {
    return {
      email: "",
      emailErrors: [],
      emailRules: [
        v => !!v || 'Please, enter email address.',
        v => Helper.isEmailValid(v) || 'Please, enter valid email address.',
      ],

      successMessage: "",

      formSubmitted: false,
    };
  },
  methods: {
    forgotPassword: async function() {
      this.emailErrors = [];
      this.successMessage = "";

      const validForm = await this.$refs.form.validate();

      if (!validForm.valid) {
        return;
      }

      try {
        this.formSubmitted = true;
        const authStore = useAuthStore();
        await authStore.forgotPassword(this.email);
        // this.$router.push('/account/reset-password/' + this.email);
        this.successMessage = `If we have your email address we have sent you a password reset email.`;
      } catch (e) {
        const code = e.code || null;

        switch (code) {
          // case 'UserNotFoundException':
          //   this.successMessage = `An email to reset your password has been sent to ${this.email}`;
          //   break;
          // case 'CodeMismatchException':
          //   this.emailErrors = "Please enter valid email address.";
          //   break;
          case 'NotAuthorizedException':
            this.emailErrors = "Your email has not been verified yet. Please contact our support team for assistance.";
            break;
          default:
            // if (e.message) {
            //   this.emailErrors = e.message;
            // } else {
            //   this.successMessage = `An email to reset your password has been sent to ${this.email}`;
            // }
            this.successMessage = `If we have your email address we have sent you a password reset email.`;
            break;
        }
      } finally {
        this.formSubmitted = false;
      }
    }
  }
}
</script>

<style>
#reset-password:focus {
  outline-width: 1px;
  outline-style: auto;
  outline-offset: 3px;
}
</style>
